import { useTranslation } from 'react-i18next';
import {
  platformIconsMapping,
  platformNamesMapping,
  availablePlatforms,
} from '../../../utils/platforms';
import { ToggleButton } from '../../ToggleButton/ToggleButton';
import { ToggleButtonGroup } from '../../ToggleButtonGroup/ToggleButtonGroup';
import { FilterCounter } from '../../FilterCounter/FilterCounter';
import { useCurrentUser } from '../../../contexts/CurrentUser';

type PlatformsFilterProps = {
  selected: string[];
  onChange: (selected: string[]) => void;
  error?: string;
  isDisabled?: boolean;
};

export const PlatformsFilter: React.FC<PlatformsFilterProps> = ({
  selected,
  onChange,
  error,
  isDisabled,
}) => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();
  const workspaceConfig = currentUser?.workspace?.config;
  const availablePlatformsConfig = workspaceConfig?.available_platforms || [];

  let availablePlatformsList: string[] = [];
  
  if (availablePlatformsConfig?.length > 0) {
    availablePlatformsList = availablePlatformsConfig;
  } else {
    availablePlatformsList = availablePlatforms;
  }

  return (
    <div className={error ? 'form-element error' : 'form-element'}>
      <label>
        {t('Platforms')}
        <FilterCounter
          selectedCount={selected.length}
          totalCount={availablePlatformsList.length}
          onReset={() => onChange([])}
          isDisabled={isDisabled}
        />
      </label>
      <ToggleButtonGroup
        padding="0"
        border="none"
        backgroundColor="transparent"
      >
        {availablePlatformsList.map((platform) => (
          <ToggleButton
            key={platform}
            text={t(platformNamesMapping[platform])}
            icon={platformIconsMapping[platform]}
            selected={selected?.includes(platform)}
            disabled={isDisabled}
            width={'159px'}
            onChange={() => {
              if (selected?.includes(platform)) {
                onChange(selected?.filter((p) => p !== platform));
              } else {
                onChange([...selected, platform]);
              }
            }}
          />
        ))}
      </ToggleButtonGroup>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};
